import { render } from "./ShorttermLegend.vue?vue&type=template&id=187d064f"
import script from "./ShorttermLegend.vue?vue&type=script&lang=js"
export * from "./ShorttermLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__